module.exports = __webpack_public_path__ + "img/uni.be8e6f17.png";